import { logoutWtApp } from "../androidAndIosApp";
import { isAppTypeIframe } from "../getAppType";
import { LocStoreInstance, useLocStore } from "../localization";
import { LocContext } from "../localization/LocContext";
import { CvpSettings } from "../settings/CvpSettings";
import { useSettings } from "../settings/useSettings";
import { redirect } from "./redirect";

export const useLogOut = () => {
  const L = useLocStore(LocContext.PROFILE);
  const settings = useSettings();

  return () => {
    if (window.iswtapp) {
      return logOutWtapp();
    }

    if (isAppTypeIframe()) {
      return logOutIframe(L, settings);
    }

    return logOutNormal();
  };
};

async function logOutIframe(L: LocStoreInstance, settings: CvpSettings) {
  redirect("/iframelogout", { mergeQs: {} });
}

function logOutWtapp() {
  logoutWtApp();
  window.location.href = getLogOutUrl();
}

function logOutNormal() {
  window.location.href = getLogOutUrl();
}

function getLogOutUrl() {
  let params = new URLSearchParams();

  if (window.cvpIdConcern) {
    params.append("k", window.cvpIdConcern.toString());
  }

  if (location.pathname === "/embedlogout") {
    params.append("embed", "true");
  }

  return "/auth/logout?" + params.toString();
}
